module.exports = __webpack_public_path__ + "img/AL803-2-EN.4a6e48ca.jpg";